export const WEBSOCKET_NOTIFICATION_NEW_CHAT_MESSAGE = 'CHATMSG';
export const WEBSOCKET_NEW_NOTIFICATION = 'WEBSOCKET_NEW_NOTIFICATION';
export const WEBSOCKET_NOTIFICATION_ANOTHER_LOGIN = 'WEBSOCKET_NOTIFICATION_ANOTHER_LOGIN';
export const WEBSOCKET_REQUESTER_CASE_STATUS_CHANGED = 'WEBSOCKET_REQUESTER_CASE_STATUS_CHANGED';
export const WEBSOCKET_NOTIFICATION_UPDATE_BOARDS = 'WEBSOCKET_NOTIFICATION_UPDATE_BOARDS';
export const WEBSOCKET_UPDATE_FORM_STRUCTURE = 'WEBSOCKET_UPDATE_FORM_STRUCTURE';
